import { action } from "satcheljs";
import { Moment } from "moment";

const saveTimeReportContents = action(
    "saveTimeReportContents",
    (
        startDate: Moment,
        endDate: Moment,
        retrieveLegacyReport: boolean,
        source?: string
    ) => ({
        startDate: startDate,
        endDate: endDate,
        retrieveLegacyReport: retrieveLegacyReport,
        source: source
    })
);

export default saveTimeReportContents;
